import { Droplets } from "lucide-react";
import { dayShort, isToday } from "./cq";

export const CqWeekStrip = ({ week, sel, onSel }) => (
  <div data-testid="cq-week-strip" className="grid grid-cols-7 gap-1.5">
    {week.days.map((d, i) => {
      const today = isToday(d.date);
      const active = i === sel;
      return (
        <button key={i} type="button" onClick={() => onSel(i)} data-testid={`cq-day-${i}`} aria-pressed={active}
          aria-label={`${d.date.toLocaleDateString("es-ES", { weekday: "long", day: "numeric" })}${d.water ? ", riego" : ", descanso"}`}
          className={`relative min-h-[68px] rounded-[14px] flex flex-col items-center justify-center gap-1 border-2 transition-[background-color,border-color,transform] active:scale-95 ${
            active ? "bg-white text-[#0F3D1E] border-white" : today ? "bg-[#1E7A3C] text-white border-[#F2B441]" : "bg-[#0F3D1E]/80 text-white border-[#8CD05A]/30"}`}>
          <span className="font-mono-d text-[11px] uppercase">{dayShort(d.date)}</span>
          <span className="font-serif-d font-black text-lg leading-none">{d.date.getDate()}</span>
          {d.water ? <Droplets className={`w-3.5 h-3.5 ${active ? "text-[#1E7A3C]" : "text-[#BFE3FF]"}`} aria-hidden /> : <span className="h-3.5 text-[10px]">·</span>}
          {today && <span className="absolute -top-2 bg-[#F2B441] text-[#0F3D1E] font-mono-d text-[9px] font-bold uppercase px-1.5 rounded-full">Hoy</span>}
        </button>
      );
    })}
  </div>
);
